import { ConfigProvider, type ConfigProviderProps, Grid, type ThemeConfig } from 'antd'

const compactTokens: ThemeConfig['token'] = {
  paddingXS: 6,
  paddingSM: 10,
  padding: 14,
  paddingLG: 20,
  paddingXL: 28,
  marginXS: 6,
  marginSM: 10,
  margin: 14,
  marginLG: 20,
}

const comfortableTokens: ThemeConfig['token'] = {
  paddingXS: 8,
  paddingSM: 12,
  padding: 16,
  paddingLG: 24,
  paddingXL: 32,
  marginXS: 8,
  marginSM: 12,
  margin: 16,
  marginLG: 24,
}

type ComponentsConfig = NonNullable<ThemeConfig['components']>

const compactComponents: ComponentsConfig = {
  Menu: {
    itemHeight: 36,
    itemPaddingInline: 14,
    itemMarginInline: 4,
    itemMarginBlock: 3,
    iconSize: 16,
    iconMarginInlineEnd: 10,
    collapsedIconSize: 16,
    subMenuItemHeight: 32,
  },
}

const comfortableComponents: ComponentsConfig = {
  Menu: {
    itemHeight: 40,
    itemPaddingInline: 16,
    itemMarginInline: 4,
    itemMarginBlock: 4,
    iconSize: 16,
    iconMarginInlineEnd: 10,
    collapsedIconSize: 18,
    subMenuItemHeight: 36,
  },
}

function mergeComponents(base: ComponentsConfig | undefined, overlay: ComponentsConfig): ComponentsConfig {
  const merged: ComponentsConfig = { ...base }
  for (const key of Object.keys(overlay) as Array<keyof ComponentsConfig>) {
    merged[key] = { ...base?.[key], ...overlay[key] } as ComponentsConfig[typeof key]
  }
  return merged
}

export function ResponsiveConfigProvider({ children, theme, ...rest }: ConfigProviderProps) {
  const screens = Grid.useBreakpoint()
  const isComfortable = !!screens.xl
  const mergedTheme: ThemeConfig = {
    ...theme,
    token: {
      ...theme?.token,
      ...(isComfortable ? comfortableTokens : compactTokens),
    },
    components: mergeComponents(theme?.components, isComfortable ? comfortableComponents : compactComponents),
  }
  return (
    <ConfigProvider {...rest} theme={mergedTheme} componentSize={isComfortable ? 'middle' : 'small'}>
      {children}
    </ConfigProvider>
  )
}
